import styled from 'styled-components'
import { Select } from '@material-ui/core'
import { theme } from '../../../../../../theme/Global'

export const ProductSelection = styled(Select)`
  &&& {
    color: ${theme.colors.text};
    align-items: center;
    box-sizing: unset;
    cursor: pointer;
    display: flex;
    margin-left: 4px;
    padding: 0 0 0 15px;
    font-size: inherit;
  }
`
